import { render, staticRenderFns } from "./worksContent.vue?vue&type=template&id=61694727&"
import script from "./worksContent.vue?vue&type=script&lang=js&"
export * from "./worksContent.vue?vue&type=script&lang=js&"
import style0 from "./worksContent.vue?vue&type=style&index=0&id=61694727&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61694727')) {
      api.createRecord('61694727', component.options)
    } else {
      api.reload('61694727', component.options)
    }
    module.hot.accept("./worksContent.vue?vue&type=template&id=61694727&", function () {
      api.rerender('61694727', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/worksContent.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/worksContent.vue
// module id = 15AV
// module chunks = 0